namespace HA.Core.HTML.Navigation {
    //noinspection TsLint
    export class NavBack extends Item {
    }
}
